import { Component } from '@angular/core';

@Component({
    selector: 'app-five-hundred-error',
    templateUrl: './five-hundred-error.component.html',
    styleUrls: ['./five-hundred-error.component.scss'],
})
export class FiveHundredErrorComponent {}
